import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { DeleteIcon } from '@calendly/ui/components/icons';
import { Loader } from '@calendly/ui/components/loader';
import { Popup, Title, Body, Footer } from '@calendly/ui/components/popup';
import { TextField } from '@calendly/ui/form/text-field';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
import { useBooleanState } from 'hooks/useBooleanState';
const MAX_INTERNAL_NOTE_LENGTH = 165;
const centeredLabelCss = "c1n8u1lj";
const CenteredLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(centeredLabelCss, props.className)} />;
});
const spacingCss = "s1qsh8co";
const Spacing = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(spacingCss, props.className)} />;
});
const counterCss = "cwvggos";
const Counter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(counterCss, props.className)} />;
});
const styledHeaderCss = "s119km8s";
const StyledHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledHeaderCss, props.className)} />;
});
const newDeleteButtonCss = "n1v129hv";
const NewDeleteButton = forwardRef((props, ref) => {
  const {
    loading,
    ...restProps
  } = props;
  const disabled = props.disabled || loading;
  return <BareButton ref={ref} {...restProps} disabled={disabled} aria-label={I18n.t('publisher.event_type_editor.header.settings.internal_note.delete')} className={classNames(newDeleteButtonCss, props.className)}>
      {loading ? <Loader size="small" /> : <DeleteIcon size="large" />}
    </BareButton>;
});
export const InternalNotePopup = ({
  internalNote,
  onConfirm,
  onClose,
  isOpen
}) => {
  const [isSubmitting, setIsSubmitting, unsetIsSubmitting] = useBooleanState(false);
  const [isDeleting, setIsDeleting, unsetIsDeleting] = useBooleanState(false);
  const [value, setValue] = useState(internalNote || '');
  useEffect(() => {
    setValue(internalNote || '');
  }, [internalNote]);
  const onSubmit = async () => {
    setIsSubmitting();
    const submitValue = value || null;
    const success = await onConfirm(submitValue);
    if (success && !success?.error) {
      onClose();
      unsetIsSubmitting();
    }
  };
  const onDelete = async () => {
    setIsDeleting();
    const success = await onConfirm(null);
    if (success && !success?.error) {
      onClose();
      unsetIsDeleting();
    }
  };
  const applyLabel = I18n.t('publisher.action.apply');
  return <Popup onClose={onClose} isOpen={isOpen}>
      <StyledHeader>
        <Title>
          {internalNote ? I18n.t('publisher.event_types.internal_note.edit') : I18n.t('publisher.event_types.internal_note.add')}
        </Title>
        {internalNote && <NewDeleteButton onClick={onDelete} loading={isDeleting} disabled={isSubmitting} />}
      </StyledHeader>
      <Body>
        <CenteredLabel htmlFor="internal-note">{I18n.t('publisher.event_types.internal_note.description')}</CenteredLabel>
        <Spacing>
          <TextField id="internal-note" type="textarea" name="internal_note" maxLength={MAX_INTERNAL_NOTE_LENGTH} value={value} placeholder={I18n.t('publisher.event_types.internal_note.placeholder')} onChange={e => setValue(e.target.value)} rows="4" />
          <Counter>
            {MAX_INTERNAL_NOTE_LENGTH - value.length}
            {' '}
            {I18n.t('publisher.event_types.internal_note.chars_left')}
          </Counter>
        </Spacing>
        <Spacing>
          {I18n.t('publisher.event_type_editor.header.settings.internal_note.invitees_message')}
        </Spacing>
      </Body>
      <Footer>
        <Button decoration="secondary-outline" onClick={onClose}>{I18n.t('publisher.action.cancel')}</Button>
        <Button onClick={onSubmit} loading={isSubmitting} disabled={isDeleting}>
          {applyLabel}
        </Button>
      </Footer>
    </Popup>;
};

require("./internal_note_popup.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./internal_note_popup.js");